/* eslint-disable sonarjs/no-duplicate-string */
import classnames from "classnames";
import React, { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FormControl } from "../../Form/Form";
import FormHelper from "../../Form/FormHelper";
import RadioButton from "../../Form/RadioButton";

import {
  getUrlSlug
} from "../../../helpers";

import useIntakeFormStore from "../../../store/IntakeForm.store";

import "./creditQualityGroupField.scss";

const CreditQualityGroupField = () => {
  const [formData, formState] = useIntakeFormStore((state) => [
    state.data.formData,
    state.data.formState,
  ]);

  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const selectedCreditQuality = useWatch({
    control,
    name: "creditQuality",
  });

  const { id: paramId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [firstSlug] = getUrlSlug(pathname);
  const isDuplicating = paramId && firstSlug === "duplicate";

  const isLocked = (formData?.submittedDate !== undefined) && !isDuplicating;
  const muniBonds = formState?.category === "Municipal Bonds";
  const corpBonds = formState?.category === "Corporate Bonds";

  if (
    selectedCreditQuality === null ||
    (isLocked && selectedCreditQuality === "")
  ) {
    setValue("creditQuality", formData?.credit_quality_SI);
  }

  const inputFields = useMemo(
    () => [
      {
        id: "creditQuality",
        name: "creditQuality",
        label: "AA and higher",
        options: {
          readOnly: corpBonds || isLocked,
          checked: selectedCreditQuality,
          options: [
            {
              subtext: "",
              label: "AA and higher",
              value: "AA,AAA",
              layout: "horizontal",
            },
          ],
        },
      },
      {
        id: "creditQuality",
        name: "creditQuality",
        label: "A and higher",
        options: {
          readOnly: isLocked,
          checked:
            (muniBonds && isLocked && selectedCreditQuality === "A,AA,AAA") ||
            (muniBonds && selectedCreditQuality === ""),

          options: [
            {
              subtext: "",
              label: "A and higher",
              value: "A,AA,AAA",
              layout: "horizontal",
            },
          ],
        },
      },
      {
        id: "creditQuality",
        name: "creditQuality",
        label: "BBB and higher",
        options: {
          readOnly: muniBonds || isLocked,
          checked:
            (corpBonds &&
              isLocked &&
              selectedCreditQuality === "BBB,A,AA,AAA") ||
            (corpBonds && selectedCreditQuality === ""),
          options: [
            {
              subtext: "",
              label: "BBB and higher",
              value: "BBB,A,AA,AAA",
              layout: "horizontal",
            },
          ],
        },
      },
      {
        id: "creditQuality",
        name: "creditQuality",
        label: "A and BBB only",
        options: {
          readOnly: muniBonds || isLocked,
          options: [
            {
              subtext: "",
              label: "A and BBB only",
              value: "BBB,A",
              layout: "horizontal",
            },
          ],
        },
      },
    ],
    [corpBonds, muniBonds, isLocked, selectedCreditQuality]
  );

  const errorKeys = Object.keys(errors);
  const hasError = errorKeys.some((err) => err.match(/^cqSi/));

  return (
    <FormControl className="form-control--table">
      <div
        className={classnames("credit-quality", {
          "has-error": hasError,
        })}
      >
        <table className="credit-quality__table">
          <thead>
            <tr>
              <th scope="col" className="title">
                Credit Quality (Choose One)
              </th>
            </tr>
          </thead>
          <tbody>
            {inputFields.map((item, index) => {
              return (
                <tr key={index}>
                  <RadioButton name={selectedCreditQuality} {...item} />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {hasError && (
        <FormHelper
          error={{
            message: "The Min % cannot exceed that of the Max % and vice versa",
          }}
        />
      )}
    </FormControl>
  );
};

export default CreditQualityGroupField;
